function Image($el) {
	
	function imageToEdge() {
		if($el.hasClass('extend-image')) {
			var image = $el.find('.image');
			var leftOffset = $(image).offset().left;
			var width = $(image).width();
			var newWidth = leftOffset + width;
			console.log(leftOffset);

			$(image).css({
				'left' : '-'+leftOffset+'px',
			});
		}

	}

	this.init = function ($el) {
		$el = $el;
		imageToEdge();

		$( window ).resize(function(){
			// $el.css({
			// 	'left' : 'auto',
			// 	'width' : 'auto'
			// });
			imageToEdge();
		});	
		return this;
	}


	return this.init($el);
}

export default Image;


// WEBPACK FOOTER //
// ./src/js/components/image.js